/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
} from './UserDto';

/**
 * 
 * @export
 * @interface TeamUserDto
 */
export interface TeamUserDto {
    /**
     * 
     * @type {UserDto}
     * @memberof TeamUserDto
     */
    user: UserDto;
    /**
     * The role of the user within the team.
     * @type {string}
     * @memberof TeamUserDto
     */
    role: string;
    /**
     * The time when the user has been added to the team.
     * @type {Date}
     * @memberof TeamUserDto
     */
    created: Date;
}

/**
 * Check if a given object implements the TeamUserDto interface.
 */
export function instanceOfTeamUserDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "created" in value;

    return isInstance;
}

export function TeamUserDtoFromJSON(json: any): TeamUserDto {
    return TeamUserDtoFromJSONTyped(json, false);
}

export function TeamUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': UserDtoFromJSON(json['user']),
        'role': json['role'],
        'created': (new Date(json['created'])),
    };
}

export function TeamUserDtoToJSON(value?: TeamUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': UserDtoToJSON(value.user),
        'role': value.role,
        'created': (value.created.toISOString()),
    };
}

